import loggerStyle from "../../../../commandLogger.module.css";
import loading from "../../../../../../../../assets/loading2.json";

import { Vulnerability } from "../../../../../../../../sdkStructs";
import { Player } from "@lottiefiles/react-lottie-player";

interface Props {
  data: Vulnerability;
  orderNumber: number;
}

function GenerateVulnBlock({ data, orderNumber }: Readonly<Props>) {
  return (
    <h5 className={loggerStyle.generatingText} key={data.ID}>
      <span>
        Generating vuln <span className={loggerStyle.blueText}>#{orderNumber}</span>
      </span>
      <div className={loggerStyle.animationWrapper}>
        <Player autoplay loop src={loading} className={loggerStyle.lottie} />
      </div>
    </h5>
  );
}

export default GenerateVulnBlock;
